import { TextField, FormControl } from '@mui/material';
import React from 'react';
import { FileInput, FileInputType } from '../../../components/file-input';

const SiteDescriptionPane = ({ values,onChange,readOnly,setValue,user }) => {
    const field = {
        onChange: onChange,
        readOnly: readOnly,
        setValue: setValue
    };
    return (<div className="grid12">
        <TextField {...field} name="description" value={values.description} multiline={true}
        label="Description" className="grid12-span" size="small" />
        <TextField {...field} className="grid12-6" name="rate_card_url" value={values.rate_card_url} label="Rate Card Url" />
        <TextField {...field} className="grid12-6" name="poster_portfolio_url" value={values.poster_portfolio_url} label="Poster Portfolio Url" />
        <FormControl className="grid12-span">
            <FileInput label="Upload Site Image (max 1)" maxImageSize={900} multiple={false} name="siteImages"
                fileType="IM" showPreview={true} type={FileInputType.Image}
                value={values.siteImages} {...field}
                allowDelete={user.hasPermission('sites.delete_image')} />
        </FormControl>
        <FormControl className="grid12-span">
            <FileInput label="Upload Gallery Images" maxImageSize={900} multiple={true} name="galleryImages"
                fileType="GA" showPreview={true} type={FileInputType.Image}
                value={values.galleryImages} {...field}
                allowDelete={user.hasPermission('sites.delete_image')} />
        </FormControl>
        <FormControl className="grid12-span">
            <FileInput label="Upload Layout Image (max 1)" maxImageSize={900} multiple={false} name="layoutImages"
                fileType="LA" showPreview={true} type={FileInputType.Image}
                value={values.layoutImages} {...field}
                allowDelete={user.hasPermission('sites.delete_image')} />
        </FormControl>
                
        
        </div>);
};

export default SiteDescriptionPane;